(function () {
  const CARD_SELECTOR = '.collection-view-all-card';
  const ACTIVE_CLASS = 'is-view-all-arrow-active';
  const RESETTING_CLASS = 'is-view-all-arrow-resetting';
  const HOVER_MEDIA = '(hover: hover) and (pointer: fine)';
  const DEFAULT_DURATION_MS = 200;

  function parseDurationMs(value) {
    if (!value) return DEFAULT_DURATION_MS;
    const trimmed = value.trim();
    if (trimmed.endsWith('ms')) return parseFloat(trimmed) || DEFAULT_DURATION_MS;
    if (trimmed.endsWith('s')) return (parseFloat(trimmed) || DEFAULT_DURATION_MS / 1000) * 1000;
    const parsed = parseFloat(trimmed);
    return Number.isFinite(parsed) ? parsed : DEFAULT_DURATION_MS;
  }

  function durationInMs(track) {
    const styles = getComputedStyle(track);
    const custom = styles.getPropertyValue('--view-all-icon-duration-in');
    if (custom) return parseDurationMs(custom);

    const transitionDuration = styles.transitionDuration.split(',')[0];
    return parseDurationMs(transitionDuration);
  }

  function initCard(card) {
    if (card.dataset.viewAllArrowInit === 'true') return;

    const track = card.querySelector('.collection-view-all-card__icon-track');
    if (!track) return;

    card.dataset.viewAllArrowInit = 'true';

    let activatedAt = 0;
    let resetTimer = null;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function snapReset() {
      resetTimer = null;
      card.classList.add(RESETTING_CLASS);
      card.classList.remove(ACTIVE_CLASS);
      void track.offsetWidth;
      card.classList.remove(RESETTING_CLASS);
    }

    function scheduleReset() {
      if (resetTimer) clearTimeout(resetTimer);

      if (reducedMotion.matches) {
        snapReset();
        return;
      }

      const remaining = Math.max(0, durationInMs(track) - (Date.now() - activatedAt));
      resetTimer = setTimeout(snapReset, remaining);
    }

    function activate() {
      if (resetTimer) {
        clearTimeout(resetTimer);
        resetTimer = null;
      }

      card.classList.remove(RESETTING_CLASS);
      card.classList.add(ACTIVE_CLASS);
      activatedAt = Date.now();
    }

    card.addEventListener('pointerenter', activate);
    card.addEventListener('pointerleave', scheduleReset);
    card.addEventListener('focusin', activate);
    card.addEventListener('focusout', scheduleReset);
  }

  function init() {
    if (!window.matchMedia(HOVER_MEDIA).matches) return;
    document.querySelectorAll(CARD_SELECTOR).forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
